import { SVGProps } from "react";

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.81348 16.1872L16.1878 3.81283" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
<path d="M3.81348 3.81281L16.1878 16.1872" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
</svg>
);
